import { css } from "@emotion/react";
import { appColor } from "@unit/styles";
import { SVGImgInitialTitle } from "@unit/svgs";
import { motion } from "framer-motion";
import React from "react";

const InitialFadeOutTitlesProvider: React.FC = () => {
  return (
    <motion.div css={initialTitleStyled} initial={{ opacity: 1 }} transition={{ delay: 1.5 }}>
      <SVGImgInitialTitle />
    </motion.div>
  );
};
export default React.memo(InitialFadeOutTitlesProvider);

const initialTitleStyled = css`
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 10;
  background-color: ${appColor.App.white};
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
